export default {
  apiUrl: process.env.REACT_APP_BASE_URL || "/api/v1",
};
